<script lang="ts">
  import Container from '$components/News/Container.svelte';
  import FullWidthContainer from '$components/News/FullWidthContainer.svelte';

  export let fullWidth: boolean | undefined = undefined;
</script>

{#if fullWidth}
  <FullWidthContainer>
    <slot name="carousel" />
  </FullWidthContainer>
  <Container>
    <slot name="caption" />
  </Container>
{:else}
  <slot name="carousel" />
  <slot name="caption" />
{/if}
